<template>
  <div
    class="flex flex-1 flex-col items-center justify-center font-primary px-6"
  >
    <div
      class="w-[200px] tablet-v:w-[250px] h-[240px] tablet-v:h-[300px] shrink-0 bg-center bg-contain bg-no-repeat mb-11 tablet-v:mb-[35px]"
      :style="imageStyles"
    />
    <div
      class="font-semibold font-primary text-[40px] tablet-v:text-[56px] tablet-h:text-[80px] text-gray-800 mb-5"
    >
      Oops!
    </div>
    <div
      class="max-w-[435px] font-semibold font-primary text-[24px] tablet-h:text-[28px] mb-[30px] text-center"
    >
      We can't seem to find the page you're looking for.
    </div>
    <div class="font-secondary text-[17px] tablet-h:text-[20px] text-gray-800">
      You can return back
      <RouterLink to="/" class="text-link">home</RouterLink> or visit
      <span class="inline-flex items-center">
        <a href="https://help.dacr.com" target="_blank" class="text-link">
          support
        </a>
        .
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const imageStyles = computed(() => ({
  backgroundImage: `url("${
    new URL('../../assets/images/404.png', import.meta.url).href
  }")`,
}))
</script>
